import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-drawer',
  imports: [],
  templateUrl: './notification-drawer.component.html',
  styleUrl: './notification-drawer.component.scss'
})
export class NotificationDrawerComponent {

}
